import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    BymoPagePropsContentSettingSemanticMeaning,
    BymoPagePropsContentSettingSpecialSemanticMeaning,
    BymoPagePropsContentSettingType,
    bymoPagePropsCreateContentSettingMetadata
} from '../../client-server-common';
import type {HideableValue} from "@wix/devzai-utils-common";
import {hideableValueCreateHidden} from "@wix/devzai-utils-common";

export namespace DoppeActionTypeCode {

    export interface ActionSettings {
        code: string;
        buttonText: HideableValue<string>;
    }
}

export const doppeLockActionTypeCode = doppeActionTypeDefineMetadata<DoppeActionTypeCode.ActionSettings>({
    id: 'io.bymo.action/code',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        buttonText: hideableValueCreateHidden(''),
        media: null,
        code: '',
    }),
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            code: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
            buttonText: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSemanticMeaning.EntityActionButtonText)
        },
        supportsActionCtaButtons: false,
        supportsContentSections: false,
        hideableContentSettingsNames: {
                buttonText: true
            }
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: true,
    isLinkOpener: false,
    isLockAction: true,
    canRenderInPage: true,
    skipReportingOnGoalAchievedOnActionButtonClick: true,
    prepareForViewer: (actionSettings, options) => {
        if (options.omitLockedActionsSettings) {
            const codeLength = Math.max(4, Math.min(actionSettings.code.length, 8))
            actionSettings.code = "x".repeat(codeLength);
        }
    },
});
